// Pure date+time helpers for the "schedule reply" picker. Returns Date objects in local time.

export const SCHEDULE_PRESET_KEYS = ['tomorrow8', 'in2hours', 'nextMonday8'];

function atHour(date, hour) {
    const d = new Date(date);
    d.setHours(hour, 0, 0, 0);
    return d;
}

export function schedulePresetDate(preset, baseDate = new Date()) {
    switch (preset) {
    case 'in2hours': {
        const d = new Date(baseDate);
        d.setHours(d.getHours() + 2, d.getMinutes(), 0, 0);
        return d;
    }
    case 'tomorrow8': {
        const d = new Date(baseDate);
        d.setDate(d.getDate() + 1);
        return atHour(d, 8);
    }
    case 'nextMonday8': {
        const d = new Date(baseDate);
        const day = d.getDay(); // 0 Sun .. 6 Sat
        const daysUntilMonday = ((8 - day) % 7) || 7; // always next Monday (>=1)
        d.setDate(d.getDate() + daysUntilMonday);
        return atHour(d, 8);
    }
    default:
        return null;
    }
}

// Combine a yyyy-mm-dd string and a HH:mm string into a local Date (null if incomplete).
export function combineDateTime(dateStr, timeStr) {
    if (!dateStr) return null;
    const [y, m, d] = dateStr.split('-').map(n => parseInt(n, 10));
    const [hh, mm] = (timeStr || '08:00').split(':').map(n => parseInt(n, 10));
    return new Date(y, m - 1, d, hh || 0, mm || 0, 0, 0);
}

// Format a Date as yyyy-mm-dd / HH:mm for native inputs.
export function toDateInputValue(date) {
    if (!date) return '';
    const d = new Date(date);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
export function toTimeInputValue(date) {
    if (!date) return '';
    const d = new Date(date);
    return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}
